import type { IconProps } from '../types'

const SuccessAlert = ({ width = '36px', height = '36px' }: IconProps) =>
  <svg width={width} height={height} viewBox="0 0 36 36">
    <defs>
    </defs>
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path fill="#FFF" d="M18 0C8.064 0 0 8.064 0 18s8.064 18 18 18 18-8.064 18-18S27.936 0 18 0z"/>
      {/* eslint-disable-next-line max-len */}
      <path fill="#27A555" d="M18 30c-6.627 0-12-5.373-12-12S11.373 6 18 6s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S23.523 8 18 8 8 12.477 8 18s4.477 10 10 10zm-2-7.414l7.293-7.293a1 1 0 0 1 1.414 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 20.586z"/>
    </g>
  </svg>

export { SuccessAlert }
